import cloneDeep from 'clone-deep'
import { InputType } from 'config'
import { useState } from 'react'
import { downloadFile, downloadPayoff } from 'services'
import { Modal } from 'stories/components'
import { InputConvert, InputValidate } from 'utils'
import { RenderInput } from 'utils/RenderInput'

const defaultInputs: Record<string, InputType> = {
  payoffDate: {
    inputType: 'text',
    type: 'date',
    title: 'Good through Date',
    required: true,
  },
  emailTo: {
    inputType: 'text',
    title: 'Email to',
    required: true,
  },
}
export const GeneratePayoffModal = ({ onClose }: { onClose: Function }) => {
  const [loading, setLoading] = useState(false)
  const [inputs, setInputs] = useState(defaultInputs)

  const onChange = (key: string, value: any) => {
    let newInputs = cloneDeep(inputs)
    value = InputConvert(newInputs[key], value)
    newInputs[key].error = InputValidate({ ...newInputs[key], value })
    newInputs[key].value = value
    setInputs(newInputs)
  }

  const onSubmit = async () => {
    let hasError = false
    let newInputs = cloneDeep(inputs)

    const data: Record<string, any> = {}
    for (const key in inputs) {
      newInputs[key].error = InputValidate(newInputs[key])
      data[key] = newInputs[key].value
      if (newInputs[key].error) hasError = true
    }
    setInputs(newInputs)
    if (hasError) return
    setLoading(true)
    const pdfData = await downloadPayoff(data)
    downloadFile(`Payoff Statement.pdf`, pdfData)
    setLoading(false)
    onClose()
  }

  return (
    <Modal isOpen title="Generate Payoff" titleOkay="Ok" onOk={onSubmit} onClose={() => onClose()} loading={loading}>
      <div className="min-w-[300px] grid grid-cols-1 gap-2">
        {Object.keys(inputs).map((key) => {
          const input = inputs[key]
          return <RenderInput input={input} Key={key} onChange={onChange} />
        })}
      </div>
    </Modal>
  )
}
